import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';

import { IState } from 'models/reducers/i-state.interface';
import { IVipPointsHistoryItem } from 'models/vip/i-points-history.interface';

import { getVipPointsHistory } from 'services/vip-points.service';

import { queryKeys } from './query-keys';

export interface UseVipPointsHistoryReturn {
  history: IVipPointsHistoryItem[];
  totalCount: number;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
  loading: boolean;
  error: string | null;
  refetch: () => void;
}

export const useVipPointsHistoryQuery = (
  page: number,
  pageSize: number = 10,
  enabled = true
): UseVipPointsHistoryReturn => {
  const walletAddress = useSelector((state: IState): string => state.wallet.address);

  const {
    data,
    isLoading,
    error,
    refetch,
  } = useQuery({
    queryKey: queryKeys.vipPoints.history(page, pageSize),
    queryFn: () => getVipPointsHistory(new AbortController().signal, page, pageSize).then((res) => res.data),
    enabled: !!walletAddress && enabled,
    staleTime: 30000,
    retry: 1,
  });

  return {
    history: data?.results ?? [],
    totalCount: data?.count ?? 0,
    hasNextPage: Boolean(data?.next),
    hasPreviousPage: Boolean(data?.previous),
    loading: isLoading,
    error: error ? (error instanceof Error ? error.message : 'Failed to fetch VIP points history') : null,
    refetch,
  };
};
